/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
/**
 * Created by rwilliams on 10/10/17.
 */
function ExternalMetadataEditViewController(this: JS5Object, _: JS5Object, $route: JS5Object,
                                            $routeParams: JS5Object, $location: JS5Object, $timeout: JS5Function,
                                            ExternalMetadataService: JS5Object,
                                            BreadcrumbService: JS5Object, UtilsService: JS5Object,
                                            MacCaptionTemplatesService: JS5Object) {
    let originalEditData: JS5Object;
    this.systemNameLocked = true;
    this.showSystemNamePadLock = true;
    let parentBreadcrumb = {
        location: '/system/aggregation/setup',
        name: 'Setup'
    };

    const validateExternalIngestType = () => {
        let ingestType = _.get(this.externalIngestTypes, this.externalIngestType);
        if (!_.isNil(ingestType)) {
            this.externalIngestTypeDisplayText = _.get(ingestType, 'displayName');
            $location.url(`/system/aggregation/edit/${$routeParams.id}/${ingestType.value}`);
            return true;
        }
        return false;
    };

    let getData = (): void => {
        BreadcrumbService.clearBreadcrumbs();
        BreadcrumbService.addBreadcrumb(parentBreadcrumb);
        MacCaptionTemplatesService.getAllMacCaptionTemplates().then((macCaptionTemplates: JS5Object) => {
            this.availableMacCaptionTemplates = macCaptionTemplates
        });
        if ($routeParams.id !== '-1') {
            this.loadingIndicator.show = true;
            ExternalMetadataService.getExternalSource($routeParams.id).then((data: JS5Object) => {
                this.externalIngestType = _.get(ExternalMetadataService.getExternalSourceType(data), 'value');
                if (validateExternalIngestType()) {
                    data.priority = _.parseInt(data.priority);
                    data.ingestsPerMinute = parseFloat(data.ingestsPerMinute);
                    originalEditData = _.cloneDeep(data);
                    this.editData = data;
                    this.originalExternalSourceData = _.cloneDeep(data);
                    this.loadingIndicator.show = false;
                }
                else {
                    $location.url(parentBreadcrumb.location);
                }
            });
        } else {
            this.systemNameLocked = false;
            this.showSystemNamePadLock = false;
            this.editData = {};
        }
    };

    let saveEditData = (): void => {
        this.loadingIndicator.show = true;

        let requestMethod = _.has(this.editData, 'id') ? 'update' : 'save';

        if (_.isDate(this.editData.minimumReleaseDate)) {
            this.editData.minimumReleaseDate = this.editData.minimumReleaseDate.toISOString().split("T")[0];
        }
        if (this.editData.ingestsPerMinute <= 0) {
            this.editData.ingestsPerMinute = null;
        }

        ExternalMetadataService.saveUpdateMetadataSource(requestMethod, this.editData).then((data: JS5Object) => {
            originalEditData = _.cloneDeep(data);
            if (requestMethod === 'save') {
                $route.updateParams({id: data.id});
            }
            this.editorForm.$setPristine();
            this.loadingIndicator.show = false;
        });
    };

    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => {
                let enableSave = !_.get(this.editorForm, '$pristine') && _.get(this.editorForm, '$valid');
                let requiredFields = [
                    'name',
                    'systemName'
                ];
                switch (this.externalIngestType) {
                    case this.externalIngestTypes.watchFolder.value:
                        requiredFields.push('watchFolderPath');
                        requiredFields.push('xslTemplate');
                        break;
                    case this.externalIngestTypes.jsonFeed.value:
                        requiredFields.push('feedUrl');
                        requiredFields.push('pollInterval');
                        requiredFields.push('channelTitle');
                        break;
                    default:
                        break;
                }
                _.forEach(requiredFields, (requireField: string) => {
                    enableSave = enableSave && _.size(_.get(this.editData, requireField));
                });
                return enableSave;
            },
            onClick: saveEditData
        },
        {
            label: 'Revert',
            enabled: () => {
                let revertEnabled = true;
                if ($routeParams.id !== '-1') {
                    revertEnabled = this.editorForm && !this.editorForm.$pristine
                }
                return revertEnabled;
            },
            onClick: () => {
                this.editData = _.cloneDeep(originalEditData);
                this.editorForm.$pristine = true;
                this.editorForm.$setPristine();
                if ($routeParams.id === '-1') {
                    $location.url(parentBreadcrumb.location);
                }
            }
        },
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => {
                $location.url(parentBreadcrumb.location);
            }
        }
    ];

    this.$onInit = (): void => {
        this.externalIngestType = $routeParams.externalIngestType;
        this.externalIngestTypes = UtilsService.externalIngestTypes;
        if ((_.isNil(this.externalIngestType) && $routeParams.id !== '-1') || validateExternalIngestType()) {
            getData();
        }
        else {
            $location.url(parentBreadcrumb.location);
        }
    };

    this.$postLink = (): void => {
        $timeout(() => {
            ExternalMetadataService.editorForm = this.editorForm
        });
    };
}

angular.module('prism-ui.externalMetadata').component('externalMetadataEditView', {
    bindings: {
        xslTemplates: '<'
    },
    controller: ExternalMetadataEditViewController,
    templateUrl: 'system/externalMetadata/setup/editor/external-metadata-edit-view-template.html'
});
